import { useEffect, useMemo, useState } from "react";
import { useAuth } from "@clerk/react";
import { useSearchParams } from "react-router-dom";
import { MessagesSquare, Lightbulb } from "lucide-react";
import Shell from "@/components/Shell";
import { makeApi } from "@/lib/api";
import ForumTab from "@/components/community/ForumTab";
import SuggestionsTab from "@/components/suggestions/SuggestionsTab";
import FleetPhotos from "@/components/community/FleetPhotos";

const TABS = [
  { id: "forum", label: "Community Forum", icon: MessagesSquare, hint: "Public to members" },
  { id: "suggestions", label: "App Suggestions", icon: Lightbulb, hint: "Private — only the CarrierLaunch team sees these" },
];

export default function Community() {
  const { getToken } = useAuth();
  const api = useMemo(() => makeApi(getToken), [getToken]);
  const [me, setMe] = useState(null);
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "suggestions" ? "suggestions" : "forum";

  useEffect(() => {
    api.get("/community/me").then(({ data }) => setMe(data)).catch(() => setMe({ access: false, reason: "Could not load the Community. Refresh to try again." }));
  }, [api]);

  return (
    <Shell>
      <div className="mb-6">
        <div className="font-mono-label text-xs text-[#FFD600] mb-2">COMMUNITY</div>
        <h1 className="font-heading font-black text-4xl sm:text-5xl leading-none" data-testid="community-title">Carrier Community.</h1>
      </div>
      <FleetPhotos />
      <div className="flex border-b border-[#262626] mb-6 overflow-x-auto" role="tablist" data-testid="community-tabs">
        {TABS.map((t) => {
          const active = t.id === tab;
          return (
            <button key={t.id} role="tab" aria-selected={active} data-testid={`community-tab-${t.id}`}
              onClick={() => setParams(t.id === "forum" ? {} : { tab: t.id }, { replace: true })}
              className={`shrink-0 px-4 sm:px-5 py-3 -mb-px border-b-2 text-left transition-colors ${active ? "border-[#FFD600] text-white" : "border-transparent text-muted-foreground hover:text-white"}`}>
              <div className="inline-flex items-center gap-2 font-semibold text-sm whitespace-nowrap"><t.icon size={15} className={active ? "text-[#FFD600]" : ""} /> {t.label}</div>
              <div className="hidden sm:block text-[11px] text-muted-foreground mt-0.5">{t.hint}</div>
            </button>
          );
        })}
      </div>
      {!me && <div className="font-mono-label text-xs text-muted-foreground">LOADING…</div>}
      {me && tab === "forum" && <ForumTab api={api} me={me} />}
      {me && tab === "suggestions" && <SuggestionsTab api={api} isAdmin={!!me.is_mod} />}
    </Shell>
  );
}
